import * as moment from "moment";
import { createValidator } from "not-valid";

export const dateOfBirthInRange = createValidator(
    (value: moment.Moment) => !value.isBefore(moment().subtract(100, "years")) && !value.isAfter(moment().subtract(13, "years")),
    "Please check Date of Birth. Age should be between 13 and 100 years.");
